import { NgClass } from "@angular/common";
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormatedSavedFilter } from "@teammood/filter";

@Component({
    selector: 'saved-filter-selector',
    templateUrl: './saved-filter-selector.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass],
})
export class SavedFilterSelectorComponent {

    @Input() filters: FormatedSavedFilter[];
    @Input() selectedNamedFilter: FormatedSavedFilter;
    @Input() createLink: boolean = true;

    @Output() onSelectionChange = new EventEmitter();

    displayList = false;

    constructor() {}

    change (element: FormatedSavedFilter) {
        const previousFilterId = this.selectedNamedFilter.id;
        this.selectedNamedFilter = element;
        this.displayList = false;
        //element.id is undefined in case of forward filter (reset on click on new)
        if (element.id === undefined || previousFilterId !== element.id) {
            this.onSelectionChange.emit(element);
        }
    }
        
}